import BezierEasing from 'bezier-easing';

export const ANIMATION_DURATION_MS = 300;
export const ANIMATION_TIMING_FUNCTION = 'cubic-bezier(0.66, 0, 0.34, 1)';
export const ANIMATION_TIMING_FUNCTION_JS = BezierEasing(0.66, 0, 0.34, 1);
